exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.responsive {\n  max-width: 100%;\n  height: auto;\n}\n", "", {"version":3,"sources":["/codebuild/output/src400947350/src/src/views/atmosphere-mask/notice.vue"],"names":[],"mappings":";AAUA;EACE,gBAAgB;EAChB,aAAa;CACd","file":"notice.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n.responsive {\n  max-width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/atmosphere-mask/notice.vue
// module id = Z0rp
// module chunks = 0